import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.sort";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '@/style/page.less';
import { getNow } from '@/utils';
import { addItem } from '@/api/shoppingcart';
import { createOrder, checkLogin, getTicketInfo } from '@/api';
import { verifyPhone, verifyId, verifyId_HUZHAO, verifyId_GANGAO, verifyId_TAIBAO } from '@/utils/validate';
import moment from 'moment';
import Steps from '@/components/Steps';
import Protocol from '@/components/Protocol';
import PageTitle from '@/components/PageTitle';
import PriceCalendar from '@/components/PriceCalendar';
import ContactSelector from '@/components/contacts/ContactSelector';
export default {
  components: {
    Steps: Steps,
    Protocol: Protocol,
    PageTitle: PageTitle,
    ContactSelector: ContactSelector,
    PriceCalendar: PriceCalendar
  },
  data: function data() {
    return {
      checked: false,
      addCartLoading: false,
      loading: false,
      pageLoading: false,
      ticketType: null,
      datePrices: [],
      datePricesMap: {},
      ticketStart: '',
      ticketEnd: '',
      selectedBatch: null,
      ticketBatches: [],
      form: {
        count: 1,
        playDate: new Date(),
        buyer_name: '',
        buyer_phone: '',
        buyer_identify: '',
        buyer_papers_type: 'ID_CARD',
        tickets: [{
          price: '',
          guest_identify: '',
          guest_name: '',
          guest_phone: '',
          play_date_begin: '',
          ticket_type_id: ''
        }]
      },
      options: [{
        value: 'ID_CARD',
        label: '身份证'
      }, {
        value: 'HUZHAO',
        label: '护照'
      }, {
        value: 'GANGAO',
        label: '港澳通行证'
      }, {
        value: 'TAIBAO',
        label: '台湾通行证'
      }],
      rules: {
        buyer_name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }]
      },
      validateList: {
        'ID_CARD': verifyId,
        'HUZHAO': verifyId_HUZHAO,
        'GANGAO': verifyId_GANGAO,
        'TAIBAO': verifyId_TAIBAO
      },
      pickerOptions: {
        disabledDate: function disabledDate() {
          return false;
        }
      }
    };
  },
  computed: {
    totalPrice: function totalPrice() {
      if (!this.selectedBatch) {
        return 0;
      }

      return (this.selectedBatch.prices[0].price * this.form.count).toFixed(2) - 0;
    },
    leftNum: function leftNum() {
      var tickets = this.form.tickets.filter(function (i) {
        return i.guest_name && i.guest_identify;
      });
      return this.form.count - tickets.length;
    },
    projectConfig: function projectConfig() {
      return this.$store.state.projectConfig;
    },
    needIdentifyType: function needIdentifyType() {
      // 是否需要其他证件类型
      return this.projectConfig && this.projectConfig.support_identity_type.length > 1;
    }
  },
  watch: {
    'form.count': {
      handler: function handler(val) {
        while (this.form.tickets.length < val) {
          var ticket = {
            guest_identify: '',
            guest_name: '',
            guest_phone: '',
            play_date_begin: '',
            price: '',
            ticket_type_id: ''
          };
          this.form.tickets.push(ticket);
        }

        if (this.form.tickets.length > val) {
          this.form.tickets.splice(val);
        }
      }
    }
  },
  created: function created() {
    this.init();
    this.form.buyer_name = this.$localStore.get('buyer_name') || '';
    this.form.buyer_phone = this.$localStore.get('buyer_phone') || '';
    this.form.buyer_identify = this.$localStore.get('buyer_identify') || '';
    this.form.buyer_papers_type = this.$localStore.get('buyer_papers_type') || 'ID_CARD';
  },
  methods: {
    verifyId: verifyId,
    verifyPhone: verifyPhone,
    init: function init() {
      var _this = this;

      checkLogin().then(function (res) {
        if (!res.data.extraInfo) {
          localStorage.removeItem('pc_token');

          _this.$router.push({
            name: 'login'
          });
        }
      });
      this.getTicketBatch();
    },
    getStock: function getStock(a) {
      if (!isNaN(Number(a))) {
        return "\u5269\u4F59:".concat(a);
      } else {
        return a;
      }
    },
    getTicketBatch: function getTicketBatch() {
      var _this2 = this;

      var ticketId = this.$route.params.id;
      var params;

      if (!this.form.playDate) {
        params = {
          id: ticketId
        };
      } else {
        params = {
          id: ticketId,
          start: moment(this.form.playDate).format('YYYY-MM-DD'),
          end: moment(this.form.playDate).format('YYYY-MM-DD')
        };
      }

      if (ticketId) {
        this.pageLoading = true;
        getTicketInfo(params).then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
            var now;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this2.ticketType = res.data.extraInfo;
                    _this2.ticketStart = new Date(moment().startOf('day'));
                    _this2.ticketEnd = new Date(moment().add(_this2.ticketType.book_future_days, 'days').valueOf());

                    _this2.pickerOptions.disabledDate = function (time) {
                      return time.getTime() < _this2.ticketStart.getTime();
                    };

                    _context.next = 6;
                    return getNow();

                  case 6:
                    now = _context.sent;
                    _this2.ticketBatches = res.data.extraInfo.batches.filter(function (item) {
                      if (item.stocks[0]) {
                        item.left_volume = item.stocks[0].sales_limit - item.stocks[0].sales_volume;
                      } else {
                        item.left_volume = 0;
                      }

                      return item.prices.length > 0 && moment(moment(_this2.form.playDate).format('YYYY-MM-DD') + ' ' + item.book_today_endtime, 'YYYY-MM-DD HH:mm:ss').isAfter(moment(now)) && item.left_volume > 0;
                    });

                    _this2.ticketBatches.sort(function (a, b) {
                      return moment(a.start_time, 'HH:mm:ss').isAfter(moment(b.start_time, 'HH:mm:ss')) ? 1 : -1;
                    });

                    _this2.selectedBatch = _this2.ticketBatches[0] || null;

                  case 10:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).finally(function () {
          _this2.pageLoading = false;
        });
      } else {
        this.$router.push({
          name: 'ticket'
        });
      }
    },
    handleUpdate: function handleUpdate(contacts) {
      this.form.tickets = contacts;
    },
    addShoppingCart: function addShoppingCart() {
      var _this3 = this;

      var order = this.getOrderInfo();

      if (this.ticketType.player_need_realname && order.tickets.some(function (item) {
        return !item.guest_name || !item.guest_identify;
      })) {
        this.$message.error('请完善出行人信息');
        return;
      }

      this.addCartLoading = true;
      addItem(order.tickets).then(function (res) {
        _this3.$message.success('添加成功');

        _this3.$store.dispatch('getCartItems');
      }).finally(function () {
        _this3.addCartLoading = false;
      });
    },
    getOrderInfo: function getOrderInfo() {
      var _this4 = this;

      var order = Object.assign({}, this.form);
      order.price = this.totalPrice;
      order.buyer_name = this.ticketType.need_realname ? order.buyer_name : '';
      order.buyer_identify = this.ticketType.need_realname ? order.buyer_identify : '';
      order.buyer_papers_type = this.ticketType.need_realname ? order.buyer_papers_type : '';
      order.tickets.forEach(function (guest) {
        guest.batch_type_id = _this4.selectedBatch.id;
        guest.ticket_type_id = _this4.ticketType.id;
        guest.price = _this4.selectedBatch.prices[0].price;
        guest.play_date_begin = _this4.formatDate(_this4.form.playDate);
      });
      return order;
    },
    toPayPage: function toPayPage() {
      var _this5 = this;

      var order = this.getOrderInfo();

      if (this.ticketType.player_need_realname && order.tickets.some(function (item) {
        return !item.guest_name || !item.guest_identify;
      })) {
        this.$message.error('请完善出行人信息');
        return;
      }

      this.$refs.buyerForm.validate(function (valid) {
        if (valid) {
          if (!_this5.checked) {
            _this5.$message.error('请确认勾选已阅读并同意购买协议');

            return;
          } // 保存购买人信息


          var _this5$form = _this5.form,
              buyer_name = _this5$form.buyer_name,
              buyer_phone = _this5$form.buyer_phone,
              buyer_papers_type = _this5$form.buyer_papers_type,
              buyer_identify = _this5$form.buyer_identify;
          order.buyer_name && _this5.$localStore.set('buyer_name', buyer_name);
          order.buyer_phone && _this5.$localStore.set('buyer_phone', buyer_phone);
          order.buyer_papers_type && _this5.$localStore.set('buyer_papers_type', buyer_papers_type);
          order.buyer_identify && _this5.$localStore.set('buyer_identify', buyer_identify);
          _this5.loading = true;
          console.log('order', order);
          createOrder(order).then(function (res) {
            console.log('res', res);

            _this5.$router.push({
              name: 'ticketPay',
              params: {
                id: res.data.extraInfo.id
              }
            });
          }).finally(function () {
            _this5.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    formatDate: function formatDate(input) {
      return moment(input).format('YYYY-MM-DD');
    },
    identifyTypeChangeToZh: function identifyTypeChangeToZh(e) {
      switch (e) {
        case 'ID_CARD':
          return '身份证';

        case 'HUZHAO':
          return '护照';

        case 'GANGAO':
          return '港澳通行证';

        case 'TAIBAO':
          return '台湾通行证';
      }
    }
  }
};